module.exports = __webpack_public_path__ + "static/media/detail3_xray_pg1.c4ca0c1e.png";